/* eslint-disable max-len */
import { LitElement, html, unsafeCSS, css } from 'lit';

import request from '../../utils/request/request';
import Logger from '../../utils/logger/logger';
import config from '../../../shared/config/config';

import styles from './blog-app-banner.component.scss';


class BlogAppBanner extends LitElement {
  static properties = {
    appId: { type: Number },
    name: { type: String },
    description: { type: String },
    iconSrc: { type: String },
    iconSrcSet: { type: String },
    url: { type: String },
  };

  static styles = css`${unsafeCSS(styles.toString())}`;

  // analogue of the componentDidMount
  // it is only needed when you insert a banner in the text editor to load app data dynamically
  async connectedCallback() {
    super.connectedCallback();

    if (this.name && this.description && this.iconSrc && this.iconSrcSet && this.url) return;

    try {
      const { name, shortDescription, icon, detailsUrl } = await request.get(`/api/apps/${this.appId}`);

      this.name = name;
      this.description = shortDescription;
      this.iconSrc = icon.src;
      this.iconSrcSet = icon.srcSet;
      this.url = detailsUrl;

      this.requestUpdate();
    } catch (error) {
      Logger.catchError('App data fetch have failed', error);
    }
  }

  render() {
    return html`
      <div class="blog-app-banner">
        <div class="blog-app-banner__icon">
          <img
            src="${this.iconSrc}"
            srcset="${this.iconSrcSet}"
            alt="${this.name}"
            width="80"
            height="80"
          />
        </div>
        <div class="blog-app-banner__content">
          <div class="blog-app-banner__description">${this.description}</div>
          <div class="blog-app-banner__title">${this.name}</div>
        </div>
        <div class="blog-app-banner__learn-more">
          <a class="blog-app-banner__learn-more-link" href="${this.url}">
            Learn more
            <svg class="blog-app-banner__learn-more-icon" height="44" viewBox="0 0 44 44" width="44" xmlns="http://www.w3.org/2000/svg">
              <g fill="none">
                <circle cx="22" cy="22" fill="#26262b" r="22"/>
                <g
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  transform="translate(13 15)"
                >
                  <path d="m0 6.8627451h17"/>
                  <path d="m11 0s2.3006536 2.30065359 6.9019608 6.90196078l-6.9019608 6.90196082"/>
                </g>
              </g>
            </svg>
          </a>
        </div>
      </div>
    `;
  }
}

const defineBlogAppBannerElement = () => {
  customElements.define(config.get('customElements').blogAppBanner, BlogAppBanner);
};

export default defineBlogAppBannerElement;
